// extracted by css-extract-rspack-plugin
export default {"world_layers_container":"world_layers_container-YYXzJi","worldLayersContainer":"world_layers_container-YYXzJi"};